// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseList from "../../../../engines/components/BaseList";
import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import RenderList from "../../../../engines/components/render/RenderList";
import O1HD from "../../../../engines/gameEngine";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";
import TaskItem from "./TaskItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskLayer extends BasePopUpLayer {

    @property(cc.Prefab)
    prefabItem: cc.Prefab = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;
    
    private itemArray: string[] = [];
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        let gameData = NormalGameManager._instance.getGameData();
        gameData.bNewTask = false;
        gameData.bNewFinshTask = false;
        NormalGameManager._instance.writeGameData();
        O1HD.emit(MessageEventKind.EventName.REFRESH_TASK_STATE);

        this.initScroll();
    }

    initScroll() {
        let content = this.scrollView.content;
        content.removeAllChildren();

        let gameData = NormalGameManager._instance.getGameData();
        for (let i in gameData.taskDataMap) {
            this.itemArray.push(i);
        }
        // for (let i = 0; i < gameData.taskDataList.length; i++) {
        //     this.itemArray.push(i);
        // }

        this.itemArray.sort((a, b) => {
            let st1 = gameData.taskDataMap[a];
            let st2 =  gameData.taskDataMap[b];

            return st1.taskState - st2.taskState;
        });

        let list = this.scrollView.getComponent(BaseList);
        list.numItems = this.itemArray.length;
    }

    renderItem(scroll: BaseList, item, idx: number) {
        let array = this.itemArray;
        let data = array[idx];
        let itemScript: TaskItem = item.getComponent(TaskItem);
        itemScript.setData(
            this
            , data
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.TaskLayer);
    }

    // update (dt) {}
}
